import React from 'react'
import { Card, CardBody, Col, Table } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList, newOrderData } from '../../../../Data/DashboardsData/ECommerceData'
import { NewOrderTitle } from '../../../../Utils/Constants'
import { H5, Image } from '../../../../AbstractElements'
import { dynamicImage } from '../../../../Utils'
import { Link } from 'react-router-dom'

export default function NewOrder() {
    return (
        <Col xxl={3} xl={5} sm={6} className="box-col-5">
            <Card>
                <DropdownWithHeader headerClass='pb-0' heading={NewOrderTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody className="pt-0 product-card">
                    <div className="table-responsive custom-scrollbar">
                        <Table className="display w-100">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Code</th>
                                    <th>price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {newOrderData.map((item) => (
                                    <tr key={item.id}>
                                        <td>
                                            <div className="d-flex">
                                                <Image src={dynamicImage(`dashboard-2/product/${item.image}`)} alt="" />
                                                <div className="flex-grow-1 ms-2">
                                                    <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product-page`}>
                                                        <span>{item.name}</span>
                                                        <H5>{item.subText}</H5>
                                                    </Link>
                                                </div>
                                                <div className="active-status active-online" />
                                            </div>
                                        </td>
                                        <td>
                                            <span>{'Coupon Code'}</span>
                                            <H5>{item.code}</H5>
                                        </td>
                                        <td>
                                            <span>{item.percent}%</span>
                                            <H5>${item.price}</H5>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}